<template>
  <VAlert
    dense
    outlined
    type="error"
  >
    <div>
      <slot name="commonText">
        <div class="mb-3">
          {{ $t('commonText', { email: supportEmail }) }}
        </div>
      </slot>
      <slot name="errorCode" v-bind="{errorMessage}">
        <div class="mb-3">
          {{ $t('code') }}: {{ errorMessage }}
        </div>
      </slot>
      <slot v-if="handleRoute" name="routerBtn" v-bind="{handleRoute}">
        <VBtn :to="handleRoute">
          {{ $t('proceed') }}
        </VBtn>
      </slot>
      <slot v-if="repeatBtn" name="routerBtn">
        <VBtn class="ml-3" color="success" @click="repeat">
          {{ $t('repeat') }}
        </VBtn>
      </slot>
    </div>
  </VAlert>
</template>

<script>
import { SUPPORT_EMAIL } from '@/helpers/constants';

export default {
  name: 'ErrorsDefault',
  props: {
    errorMessage: {
      type: String,
      required: false,
    },
    handleRoute: {
      type: Object,
      default: null,
    },
    repeatBtn: Boolean,
  },
  setup(_, { emit }) {
    return {
      repeat() {
        emit('repeat');
      },
      supportEmail: SUPPORT_EMAIL,
    };
  },
};
</script>

<style scoped>

</style>

<i18n lang="yml" locale="ru">

</i18n>

<i18n lang="yml" locale="ru">
  commonText: 'Произошла непредвиденная ошибка, попробуйте повторить попытку позднее или написать на {email}'
  code: 'Код ошибки'
  proceed: 'Продолжить'
  repeat: 'Попробовать еще раз'
</i18n>
